import React, { useContext, useState } from 'react'
import "./Shop.css"
import { NavLink } from 'react-router-dom';
import { AuthContext } from './Context';
function Tables() {
 const furnitureData=useContext(AuthContext)


    const [furniture,setFurniture]=useState("All")
    const [material,setMaterial]=useState("All Materials")
    const [size,setSize]=useState("All Sizes")

const all3SeaterArray=furnitureData.filter(furniture=>furniture.seaters===3)
const all3SeaterArrayResults=all3SeaterArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}

   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))

const all7SeaterArray=furnitureData.filter(furniture=>furniture.seaters===7)
const all7SeaterArrayResults=all7SeaterArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}

   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))

const all5SeaterArray=furnitureData.filter(furniture=>furniture.seaters===5)

const all5SeaterArrayResults=all5SeaterArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}

   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))

    const tableArray=furnitureData.filter(furniture=>furniture.category.toLocaleLowerCase().includes("table"))

    const tableArrayResults=tableArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}

   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))

    const woodtableArray=tableArray.filter(furniture=>furniture.material.toLocaleLowerCase().includes("wood"))

    const woodtableArrayResults=woodtableArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}


   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))
    const marbletableArray=tableArray.filter(furniture=>furniture.material.toLocaleLowerCase().includes("marble"))
    const marbletableArrayResults=marbletableArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    


    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}


   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))
const seater3woodArray=woodtableArray.filter(furniture=>furniture.seaters===3)
const seater3woodArrayResults=seater3woodArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}


   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))
const seater3marbleArray=marbletableArray.filter(furniture=>furniture.seaters===3)
const seater3marbleArrayResults=seater3marbleArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}


   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))
const seater5marbleArray=marbletableArray.filter(furniture=>furniture.seaters===5)
const seater5marbleArrayResults=seater5marbleArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}


   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))
const seater7marbleArray=marbletableArray.filter(furniture=>furniture.seaters===7)
const seater7marbleArrayResults=seater7marbleArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}


   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))

const seater5woodArray=woodtableArray.filter(furniture=>furniture.seaters===5)
const seater5woodArrayResults=seater5woodArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}


   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))
const seater7woodArray=woodtableArray.filter(furniture=>furniture.seaters===7)
const seater7woodArrayResults=seater7woodArray.map((item)=>(
           <div class="morara-card">
    <NavLink to={`/products/${item.id}`}>
    
    {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
  <img
    src={item.image} alt={item.name}
    class="morara-card-img"
  />

  <h3 class="morara-card-title">{item.name}</h3>
  <p class="morara-card-desc">
    {item.description}
  </p>

  <div class="morara-subimages">

    

    {item.subimages.map((img, index) => (
  <img key={index} src={img} alt={item.name} />
))}


   
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                      style: "currency",
                      currency: "KES",
                      minimumFractionDigits: 0,
                    }).format(item.price)}</p>
  <button class="morara-btn">View</button>
  </div>
</NavLink>

</div> 

))



  return (
    <>
     
  <header class="morara-header">
    <h1 class="morara-title">Morara Home Tables</h1>
    <p class="morara-subtitle">Quality Tables • Serving Purpose</p>
  </header>

  <section class="morara-filter-bar">
  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="categorySelected" onClick={()=>{setFurniture("All")}}>{furniture}</div>
    <div class="morara-dropdown-options" id="categoryOptions">
      <div data-value="table" onClick={()=>{setFurniture("Tables")}} className={furniture==="Tables"?"furniture-active":""}>Tables</div>
    </div>
  </div>

  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="materialSelected">{material}</div>
    <div class="morara-dropdown-options" id="materialOptions">
      <div data-value="all" onClick={()=>{setMaterial("All Materials")}} className={material==="All Materials"?"furniture-active":""}> All Materials</div>
      <div data-value="wood" onClick={()=>{setMaterial("Wood")}} className={material==="Wood"?"furniture-active":""}>Wood</div>
      <div data-value="marble" onClick={()=>{setMaterial("Marble")}} className={material==="Marble"?"furniture-active":""}>Marble</div>
    </div>
  </div>

  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="seaterSelected">{size}</div>
    <div class="morara-dropdown-options" id="seaterOptions">
      <div data-value="all" onClick={()=>{setSize("All Sizes")}} className={material==="All Sizes"?"furniture-active":""}>All Sizes</div>
      <div data-value="3" onClick={()=>{setSize("3seater")}} className={material==="3seater"?"furniture-active":""}>3 Seater</div>
      <div data-value="5" onClick={()=>{setSize("5seater")}} className={material==="5seater"?"furniture-active":""}>5 Seater</div>
      <div data-value="7" onClick={()=>{setSize("7seater")}} className={material==="7seater"?"furniture-active":""}>7 Seater</div>
    
    </div>
  </div>
</section>

  <main id="moraraProducts" class="morara-products">
    
{material==="All Materials" && size==="All Sizes" && tableArrayResults}
{material==="Wood" && size=="All Sizes" && woodtableArrayResults}
{material==="Marble" && size=="All Sizes" &&  marbletableArrayResults}


{material==="All Materials" && size=="3seater" &&   all3SeaterArrayResults}
{material==="Wood" && size=="3seater" && seater3woodArrayResults}
{material==="Marble" && size=="3seater" && seater3marbleArrayResults}

{material==="All Materials" && size=="5seater" &&   all5SeaterArrayResults}
{material==="Wood" && size=="5seater" && seater5woodArrayResults}
{material==="Marble" && size=="5seater" && seater5marbleArrayResults}


{material==="Marble" && size=="7seater" && seater7marbleArrayResults}

{material==="All Materials" && size=="7seater" &&   all7SeaterArrayResults}
{material==="Wood" && size=="7seater" && seater7woodArrayResults}
{material==="Marble" && size=="7seater" && seater7marbleArrayResults}
</main>
 


    </>
  )
}

export default Tables
